import UsersBaseController from '../common/users.base.controller';
import AppConstants from '../../../config/app.constants';
class UsersEditController extends UsersBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, UsersService, $q, Modal, $translate, $stateParams, UserService, BranchService, $scope, SetupService, LogService,
		BranchFundingSourceService, UserBranchFundingSourceService, TimezoneList, CustomerService, CommonLayoutService, LocationZoneService, AtmMakesService, Configs) {

		super(Auth, $state, User, UsersService, Modal, $translate, $stateParams, $scope)
		this.Configs = Configs
		this.UserService = UserService
		this.BranchService = BranchService
		this.SetupService = SetupService
		this.logService = LogService
		this.Modal = Modal
		this.$q = $q
		this.$scope = $scope;
		this.UsersService = UsersService
		this.permissions = this.Auth.permission();
		this.aclPermissions = []
		this.BranchFundingSourceService = BranchFundingSourceService;
		this.UserBranchFundingSourceService = UserBranchFundingSourceService;
		this.TimezoneList = TimezoneList;
		this.CustomerService = CustomerService;
		this.CommonLayoutService = CommonLayoutService;
		this.LocationZoneService = LocationZoneService;
		this.AtmMakesService = AtmMakesService;
		this.User = User;
		this.model = {
			id: '',
			firstName: '',
			lastName: '',
			email: '',
			supervisor: false,
			languageId: '',
			branchId: '',
			password: null,
			downloadToHHT: false,
			isWebUser: false,
			kabaKeyId: '',
			SGKeyId: '',
			sameForAll: false,
			defaultAppView: null,
			hhtPassword: null,
			phone: null,
			routeKeyId: '',
			tecnoDevId: '',
			OTCCompanyName: null,
			serviceUser: false,
			ATMTransfer: false,
			shipmentTransfer: false,
			timezone: null,
			customerUser: false,
			customer: '',
			payrollId: null,
			addActions: false,
			createTickets: false,
			serviceLevel: null,
			userOrigin: null,
			address: null,
			city: null,
			state: null,
			zip: null,
			country: null,
			isNonUSLocation: false,
			lat: null,
			long: null,
			make: [],
			schedule: {}
		}

		this.scheduleDays = [
			{ key: 'Mon', label: 'Monday', shortLabel: 'Monday', startKey: 'startTimeMon', endKey: 'endTimeMon', active: false },
			{ key: 'Tue', label: 'Tuesday', shortLabel: 'Tuesday', startKey: 'startTimeTue', endKey: 'endTimeTue', active: false },
			{ key: 'Wed', label: 'Wednesday', shortLabel: 'Wednesday', startKey: 'startTimeWed', endKey: 'endTimeWed', active: false },
			{ key: 'Thu', label: 'Thursday', shortLabel: 'Thursday', startKey: 'startTimeThu', endKey: 'endTimeThu', active: false },
			{ key: 'Fri', label: 'Friday', shortLabel: 'Friday', startKey: 'startTimeFri', endKey: 'endTimeFri', active: false },
			{ key: 'Sat', label: 'Saturday', shortLabel: 'Saturday', startKey: 'startTimeSat', endKey: 'endTimeSat', active: false },
			{ key: 'Sun', label: 'Sunday', shortLabel: 'Sunday', startKey: 'startTimeSun', endKey: 'endTimeSun', active: false },
			{ key: 'Holiday', label: 'Holiday', shortLabel: 'Holiday', startKey: 'startTimeHoliday', endKey: 'endTimeHoliday', active: false }
		];
		this.scheduleErrors = {};

		this.serviceLevelList = [
			{ label: '(None)', value: null },
			{ label: 'FLM', value: 'FLM' },
			{ label: 'SLM', value: 'SLM' }
		];

		this.userOriginList = [
			{ label: '(None)', value: null },
			{ label: 'Branch', value: 'BRANCH' },
			{ label: 'Vehicle', value: 'VEHICLE' },
			{ label: 'User', value: 'USER' }
		];
		this.atmMakesList = [];

		this.defaultAppView = [
			{
				label: 'List View',
				value: 'List'
			},
			{
				label: 'All Map View',
				value: 'All'
			},
			{
				label: 'Next Map View',
				value: 'Next'
			},
			{
				label: 'Next 3 Map View',
				value: 'Next3'
			}
		]

		this.OTCCompanyNameList = [];
		this.branch = [];
		this.role = {
			admin: false,
			user: false
		}
		this.aclRole = ''
		this.language = [{
			value: 'E',
			label: 'English'
		},
		// {
		// 	value: 'F',
		// 	label: 'French'
		// },
		{
			value: 'S',
			label: 'Spanish'
		}
		]
		this.cnfPassword = ''
		this.leader = {};
		this.existingBranch = [];
		this.localLang = {
			selectAll: this.$translate.instant('common.selectall'),
			selectNone: this.$translate.instant('common.selectnone'),
			reset: this.$translate.instant('shipmentBatch.reset'),
			search: this.$translate.instant('common.search'),
			nothingSelected: this.$translate.instant('common.noneselected'),         //default-label is deprecated and replaced with this.
		}
		this.lastUpdated = null;
		this.branchData = [];
		this.hasACL = {};
		this.defaultBranch = '';
		this.userData = [];
		this.OTCKeys = {};
		this.company = {};
		this.timezoneList = this.TimezoneList.getTimezoneList();
		this.customerList = [];
		this.totalCustomer = 0;
		this.serviceZoneData = [];
		// this.model = angular.copy(this.defaultModel)	
		// this.lockSystem = [
		// 	{
		// 		label: 'KABA FLM',
		// 		value: 'kabaKeyId'
		// 	},
		// 	{
		// 		label: 'KABA Route',
		// 		value: 'routeKeyId'
		// 	},
		// 	{
		// 		label: 'S&G',
		// 		value: 'SGKeyId'
		// 	},
		// 	{
		// 		label: 'Witz',
		// 		value: 'witzKeyId'
		// 	}
		// ];
	}
	$onInit() {
		this.loading = true;

		const validatePermissions = () => {
			return new Promise((resolve, reject) => {
				this.UsersService.validateUserPermissions(this.User.getUser().firstName, this.User.getUser().lastName)
					.then((permissions) => {
						if (!this.CommonLayoutService.isAllowToAccessPages() && !permissions.hasUserEditPermission) {
							this.$state.go('home');
							reject('User does not have sufficient permissions.');
						} else {
							resolve();
						}
					})
					.catch((err) => {
						reject(`Error validating permissions: ${err}`);
					});
			});
		};

		validatePermissions().then(() => {
			this.Configs.getConfigs().then((data) => {
				this.googleMapConfig = data.googleMap;
				this.apiKey = '//maps.google.com/maps/api/js?key=' + this.googleMapConfig.key + '&libraries=places';
				setTimeout(() => {
					this.render = true;
				}, 100);
			});

			this.moment = moment;
			if (!this.model.isWebUser) {
				this.model.email = '';
				this.model.password = null;
				this.model.cnfPassword = '';
			}

			const userId = this.$stateParams.id;

			this.$q.all([
				this.BranchService.all(null, 0, 1000),
				this.SetupService.all(null, 0, 1000),
				this.logService.getLogInfo('update-user', userId),
				this.Service.get(userId),
				this.UserService.getUserBranchGroup(userId),

			])
				.then((data) => {
					this.OTCCompanies = data[3].companies;
					this.setOtcKeys();
					this.OTCCompanyMap();
					this.defaultModel = data[3];
					this.rawId = data[3].id
					this.model.id = data[3].id
					this.model.firstName = data[3].firstName
					this.model.lastName = data[3].lastName
					this.model.email = data[3].email
					this.model.languageId = data[3].languageId
					this.model.supervisor = data[3].supervisor
					this.model.branchId = data[3].branchId
					this.defaultBranch = data[3].branchId
					this.model.downloadToHHT = data[3].downloadToHHT
					this.model.isWebUser = !data[3].customerUser && !!data[3].email
					this.model.branchPermission = data[3].branchId;
					this.model.kabaKeyId = data[3].kabaKeyId;
					this.model.SGKeyId = data[3].SGKeyId;
					this.model.defaultAppView = data[3].defaultAppView || null;
					this.model.hhtPassword = data[3].hhtPassword;
					this.model.phone = data[3].phone
					this.model.routeKeyId = data[3].routeKeyId
					this.model.tecnoDevId = data[3].tecnoDevId
					this.model.OTCCompanyName = data[3].OTCCompanyName
					this.OTCKeys = data[3].OTCKeys || this.OTCKeys;
					this.model.serviceUser = data[3].serviceUser;
					this.model.ATMTransfer = data[3].ATMTransfer;
					this.model.shipmentTransfer = data[3].shipmentTransfer;
					this.model.timezone = data[3].timezone;
					this.model.customerUser = data[3].customerUser;
					this.model.customer = data[3] && data[3].customer ? this.mappingCustomerKeyVal(data[3].customer) : null;
					this.model.autoCheckIn = data[3].downloadToHHT ? data[3].autoCheckIn || false : false;
					this.model.autoCheckOut = data[3].downloadToHHT ? data[3].autoCheckOut || false : false;
					this.model.payrollId = data[3].payrollId;
					this.model.limitToServiceZone = data[3].serviceUser ? data[3].limitToServiceZone || false : false;
					this.model.rejectTickets = (data[3].serviceUser || data[3].downloadToHHT) ? data[3].rejectTickets : false;
					this.model.selfAssignServiceTicket = data[3].serviceUser ? data[3].selfAssignServiceTicket : false;
					this.model.userAssignServiceTicket = data[3].serviceUser ? data[3].userAssignServiceTicket : false;
					this.model.addActions = data[3].serviceUser ? data[3].addActions || false : false;
					this.model.createTickets = data[3].serviceUser ? data[3].createTickets || false : false;
					this.model.branchCounterId =  data[3].branchCounterId  ||  null;
					this.model.serviceLevel = data[3].serviceLevel || null;
					this.model.userOrigin = data[3].userOrigin || null;
					this.model.address = data[3].address || null;
					this.model.city = data[3].city || null;
					this.model.state = data[3].state || null;
					this.model.zip = data[3].zip || null;
					this.model.country = data[3].country || null;
					this.model.isNonUSLocation = data[3].country && data[3].country !== 'US' ? true : false;
					this.model.lat = data[3].lat || null;
					this.model.long = data[3].long || null;
					this.loadSchedule(data[3].schedule);
					this.loadAtmMakes(data[3].make);
					if (!data[3].hasAtmCodesPermission && !this.CommonLayoutService.isAllowToAccessPages()) {
						delete this.permissions.atm_codes_management;
					}

					if (!data[3].hasSettingsPermission && !this.CommonLayoutService.isAllowToAccessPages()) {
						delete this.permissions.setting;
					}

					if (!data[3].hasTntBypassCodePermission && !this.CommonLayoutService.isAllowToAccessPages()) {
						delete this.permissions.branch_mgmt.child.branch_mgmt_tnt_bypass_code;
					}

					if (!data[3].hasEnvironmentConfigPermission && !this.CommonLayoutService.isAllowToAccessPages()) {
						delete this.permissions.tnt_control.child.tnt_control_environment_config;
					}

					if (!data[3].vaultOpartionPermission && !this.CommonLayoutService.isAllowToAccessPages()) {
						delete this.permissions.vault_operations;
					}

					this.UserService.acl(this.rawId, this.model.branchId)
						.then((data) => {
							this.aclPermissions = data;
							this.sanitizeCashActivityPermissions(this.aclPermissions);
						})
					this.UserService.role(this.rawId, this.model.branchId)
						.then((data) => {
							this.aclRole = data
							this.role.user = this.aclRole.find((role) => {
								return role !== 'admin';
							});

						})

					this.lastUpdated = data[2].results || null;
					this.setupInfo = data[1].results;

					const branchesWithExistingSetupRecord = this.setupInfo.map((setupRecord) => {
						return setupRecord.branchId;
					});

					this.branchData = data[0].results
						.filter((branch) => branchesWithExistingSetupRecord.includes(branch.id));

					this.branchData.filter((branch) => {
						return branch.id === this.model.branch;
					})

					this.existingBranch = data[4];
					data[4].forEach((selectedBranch) => {
						this.branchData.filter((branch) => {
							if (branch.id == selectedBranch.branchId) {
								branch.ticked = true;
							}
						})
					});

					this.defaultModel.usersBranches = this.branchData.map(b => { if (b.ticked) return b.id }).filter(n => n !== undefined);
					this.defaultModel.OTCKeys = _.cloneDeep(this.OTCKeys);
					const savedZoneIds = this.model.limitToServiceZone
						? (data[3].serviceZoneData || []).map(zone => zone.zoneId)
						: [];
					this.loadServiceZone(this.existingBranch.map(branch => branch.branchId), savedZoneIds)
						.then(() => {
							this.defaultModel.serviceZoneData = this.serviceZoneData
								.filter(zone => zone && zone.zoneId != null && zone.ticked)
								.map(zone => ({ locationZoneId: zone.zoneId, userId: this.model.id }));
						});

					this.getCustomer('', 0);
					this.getSetupDetails();
					this.validateAutoChekInChekOut();
					this.forceSupervisorToSetOn();
					this.getBranchCounters()
				})
				.then(() => {
					this.getUserbranchFundingSource().then(() => this.getFundingSource(this.existingBranch)).catch();
				})
				.catch((err) => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				})
		})
	}

	sanitizeCashActivityPermissions(permissions) {
		if (permissions && permissions['cash_activity']) {
			const cashAct = permissions['cash_activity'];
			
			if (cashAct.includes('customer') && cashAct.includes('funding_source')) {
				if (this.model.customerUser) {
					permissions['cash_activity'] = ['customer'];
					this.UserService.updateAcl({
						role: 'user:' + this.rawId,
						resource: 'cash_activity',
						permission: ['funding_source'],
						user: this.rawId,
						branchIds: [this.model.branchPermission || this.model.branchId]
					}, false);
				} else {
					permissions['cash_activity'] = ['funding_source'];
					this.UserService.updateAcl({
						role: 'user:' + this.rawId,
						resource: 'cash_activity',
						permission: ['customer'],
						user: this.rawId,
						branchIds: [this.model.branchPermission || this.model.branchId]
					}, false);
				}
			}
		}
	}

	hasAclRole() {
		return this.aclRole.length > 0
	}

	format(key, parentKey) {
		if (parentKey === 'branch_mgmt_orders' && key === 'all') {
			return this.$translate.instant('common.View');
		}
		if (typeof (key) == 'string') {
			key = key.replace('_', '-');
			key = (key !== 'assign' && key !== 'export') ? key.charAt(0).toUpperCase() + key.slice(1) : key;
			key = this.$translate.instant('common.' + key);
		}
		return key;
	}

	togglePerm(key, parentKey) {
		let allow = false;
		if (this.hasPerm(key, parentKey)) allow = false;
		else allow = true;

		if (allow && parentKey === 'cash_activity') {
			const otherKey = key === 'customer' ? 'funding_source' : 'customer';
			if (this.hasPerm(otherKey, parentKey)) {
				this.togglePerm(otherKey, parentKey);
			}
		}

		if (parentKey === 'cash_activity') {
			if (allow) {
				if (!this.aclPermissions) {
					this.aclPermissions = {};
				}
				const hadRedirect = this.hasPerm('default_redirect', parentKey);
				this.aclPermissions[parentKey] = hadRedirect ? [key, 'default_redirect'] : [key];
			} else {
				if (this.aclPermissions && this.aclPermissions[parentKey]) {
					this.aclPermissions[parentKey] = this.aclPermissions[parentKey].filter(k => k !== key);
				}
			}
		}

		let obj = {
			role: !allow ? ('user:' + this.rawId) : '',
			resource: parentKey,
			permission: [key],
			user: this.rawId,
			branchIds: [this.model.branchPermission]
		}

		this.$q.when()
			.then(() => {
				if (!allow && !this.role.user) {
					const defer = this.$q.defer();
					this.UserService.role(this.rawId, this.model.branchPermission)
						.then((data) => {
							this.aclRole = data
							this.role.user = this.aclRole.find((role) => {
								return role !== 'admin';
							});
							obj.role = this.role.user;
							defer.resolve();
						})
					return defer.promise;
				}
			})
			.then(() => {
				this.updateAclPermission(obj, allow, key, parentKey)
				// if (parentKey == 'setting') {
				// 	const settingChild = this.permissions.setting.child;
				// 	const resources = Object.keys(settingChild);
				// 	resources.map((resource) => {
				// 		let branchMgmtObj = {
				// 			role: !allow ? ('user:' + this.rawId) : '',
				// 			resource: resource,
				// 			permission: ["edit", "delete", "view", "create"],
				// 			user: this.rawId,
				// 			branchIds: [this.model.branchPermission]
				// 		}
				// 		if (resource == 'setting-log')
				// 			branchMgmtObj.permission = ["view"];
				// 		else if (resource == 'setting-location')
				// 			branchMgmtObj.permission = ["edit", "delete", "view", "create", "importLocations"];
				// 		else
				// 			branchMgmtObj.permission = ["edit", "delete", "view", "create"];
				// 		this.updateAclPermission(branchMgmtObj, allow, branchMgmtObj.permission, resource)
				// 	})
				// } else 
				if (parentKey == 'branch_mgmt') {
					const branchMgmtChild = this.permissions.branch_mgmt.child;
					const resources = Object.keys(branchMgmtChild);
					resources.forEach((resource) => {
						if (this.model.customerUser && this.customerPermissions.indexOf(resource) < 0) return;
						let branchMgmtObj = {
							role: !allow ? ('user:' + this.rawId) : '',
							resource: resource,
							permission: ['all'],
							user: this.rawId,
							branchIds: [this.model.branchPermission]
						}
						this.updateAclPermission(branchMgmtObj, allow, 'all', resource)
					})
				} else if (['branch_mgmt_deposit_reports', 'branch_mgmt_bin_manifest'].includes(parentKey)) {
					const resourcesToUpdate = ['tnt_react_app'];
				
					resourcesToUpdate.forEach((resource) => {
						const permObj = {
							role: !allow ? ('user:' + this.rawId) : '',
							resource: resource,
							permission: [key],
							user: this.rawId,
							branchIds: [this.model.branchPermission]
						};
				
						this.updateAclPermission(permObj, allow, key, resource);
					});
				}else if (parentKey == 'branch_mgmt_billing_approval') {
					let childPermission = this.permissions.branch_mgmt.child.branch_mgmt_billing_approval.child;
					const resources = Object.keys(childPermission);
					resources.forEach((resource) => {
						if (this.model.customerUser && this.customerPermissions.indexOf(resource) < 0) return;
						let branchMgmtObj = {
							role: !allow ? ('user:' + this.rawId) : '',
							resource: resource,
							permission: ['allow'],
							user: this.rawId,
							branchIds: [this.model.branchPermission]
						}
						this.updateAclPermission(branchMgmtObj, allow, 'allow', resource)
					})
				} else if (parentKey == 'tnt_billing_fuel_surcharges') {
					let childPermission = this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.child;
					const resources = Object.keys(childPermission);
					let childPermisions = [];
					if (allow && childPermission['edit']) childPermisions.push('edit')
					if (allow && childPermission['view']) childPermisions.push('view')
					if (allow && childPermission['create']) childPermisions.push('create')

					resources.forEach((resource) => {
						if (this.model.customerUser && this.customerPermissions.indexOf(resource) < 0) return;
						let branchMgmtObj = {
							role: !allow ? ('user:' + this.rawId) : '',
							resource: resource,
							permission: childPermisions,
							user: this.rawId,
							branchIds: [this.model.branchPermission]
						}
						this.updateAclPermission(branchMgmtObj, allow, childPermisions, resource)
					})
				} else if (['setting', 'branch_mgmt', 'tnt_billing', 'tnt_control', 'reporting', 'branch_mgmt_billing_approval', 'order_packing', 'bulk_transfer'].indexOf(parentKey) >= 0) {
					let childPermission = this.permissions[parentKey].child;
					const resources = Object.keys(childPermission);
					resources.forEach((resource) => {
						if (this.model.customerUser && this.customerPermissions.indexOf(resource) < 0) return
						let permissionKeys = Object.keys(childPermission[resource].permission).filter(p => p !== 'default_redirect');
						let branchMgmtObj = {
							role: !allow ? ('user:' + this.rawId) : '',
							resource: resource,
							permission: permissionKeys,
							user: this.rawId,
							branchIds: [this.model.branchPermission]
						}
						if (this.model.customerUser && allow) {
							if (resource == 'setting-location') {
								branchMgmtObj.permission = ["view", "edit"]
							}
							// If editing Billing Approval as a customer user, keep it view-only
							if (parentKey === 'branch_mgmt_billing_approval') {
								branchMgmtObj.permission = ['allow'];
							}
						}
						this.updateAclPermission(branchMgmtObj, allow, branchMgmtObj.permission, resource)
					})
				}
			})
			.catch((err) => {
				console.log('Error Updating permissions')
				console.log(err)
			})
	}

	allowSettings(key, parentKey) {
		let allow = false;
		if (this.hasPerm(key, parentKey)) allow = false
		else allow = true

		const hasSetting = this.aclPermissions['setting'],
			settingChild = this.permissions.setting.child,
			resources = Object.keys(settingChild),
			isSelected = resources.find(d => d === parentKey)

		if (isSelected && !hasSetting) {
			let permissionObj = {
				role: !allow ? ('user:' + this.rawId) : '',
				resource: 'setting',
				permission: ["all"],
				user: this.rawId,
				branchIds: [this.model.branchPermission]
			}
			this.updateAclPermission(permissionObj, true, 'all', 'setting')
		}
	}

	hasPerm(key, parentKey) {
		const permissionObj = this.aclPermissions[parentKey];
		if (Array.isArray(permissionObj)) {
			return permissionObj.includes(key);
		}
		else {
			return false;
		}
	}

	findResourceNode(resource) {
		if (this.permissions[resource]) return this.permissions[resource];
		for (const topVal of Object.values(this.permissions)) {
			if (topVal.child && topVal.child[resource]) return topVal.child[resource];
			if (topVal.child) {
				for (const childVal of Object.values(topVal.child)) {
					if (childVal.child && childVal.child[resource]) return childVal.child[resource];
				}
			}
		}
		return null;
	}

	hasAnyPerm(resource) {
		const permissionObj = this.aclPermissions[resource];
		if (Array.isArray(permissionObj) && permissionObj.some(p => p !== 'default_redirect')) {
			return true;
		}
		const node = this.findResourceNode(resource);
		if (node && node.child) {
			return Object.keys(node.child).some(childKey => this.hasAnyPerm(childKey));
		}
		return false;
	}

	hasChildDefaultRedirect(parentKey) {
		const parentPerm = this.permissions[parentKey];
		if (!parentPerm || !parentPerm.child) return false;
		return Object.keys(parentPerm.child).some(childKey =>
			this.hasPerm('default_redirect', childKey)
		);
	}

	getParentCategoryKey(resource) {
		if (resource.startsWith('setting-')) return 'setting';
		if (resource.startsWith('branch_mgmt_')) return 'branch_mgmt';
		if (resource.startsWith('tnt_billing_')) return 'tnt_billing';
		if (resource.startsWith('tnt_control_')) return 'tnt_control';
		if (resource.startsWith('reporting_')) return 'reporting';
		return null;
	}

	cleanupOrphanedDefaultRedirects() {
		Object.keys(this.aclPermissions).forEach((resource) => {
			const perms = this.aclPermissions[resource];
			if (Array.isArray(perms) && perms.includes('default_redirect') && !this.hasAnyPerm(resource)) {
				this.aclPermissions[resource] = perms.filter(p => p !== 'default_redirect');
				if (this.aclPermissions[resource].length === 0) {
					delete this.aclPermissions[resource];
				}
				let obj = {
					role: 'user:' + this.rawId,
					resource: resource,
					permission: ['default_redirect'],
					user: this.rawId,
					branchIds: [this.model.branchPermission]
				};
				this.UserService.updateAcl(obj, false).catch(err => console.error('Error clearing orphaned redirect ACL:', err));
			}
		});
	}

	toggleDefaultRedirect(resource) {
		const isCurrentlyChecked = this.hasPerm('default_redirect', resource) || this.hasChildDefaultRedirect(resource);

		// 1. Find all resources that currently have default_redirect
		const resourcesToClear = Object.keys(this.aclPermissions).filter(res =>
			this.hasPerm('default_redirect', res)
		);

		// 2. Update local state synchronously immediately
		resourcesToClear.forEach(res => {
			if (Array.isArray(this.aclPermissions[res])) {
				this.aclPermissions[res] = this.aclPermissions[res].filter(p => p !== 'default_redirect');
				if (this.aclPermissions[res].length === 0) {
					delete this.aclPermissions[res];
				}
			}
		});

		// 3. Sync with the database asynchronously in the background
		resourcesToClear.forEach(res => {
			let obj = {
				role: 'user:' + this.rawId,
				resource: res,
				permission: ['default_redirect'],
				user: this.rawId,
				branchIds: [this.model.branchPermission]
			};
			this.UserService.updateAcl(obj, false).catch(err => console.error('Error clearing redirect ACL:', err));
		});

		let nextResourceToSet = null;
		if (!isCurrentlyChecked) {
			nextResourceToSet = resource;
		} else {
			// If we uncheck a child/grandchild redirect, shift it back to parent category
			const parentCategory = this.getParentCategoryKey(resource);
			if (parentCategory) {
				nextResourceToSet = parentCategory;
			}
		}

		if (nextResourceToSet) {
			if (!this.aclPermissions[nextResourceToSet]) {
				this.aclPermissions[nextResourceToSet] = [];
			}
			if (!this.aclPermissions[nextResourceToSet].includes('default_redirect')) {
				this.aclPermissions[nextResourceToSet] = [...this.aclPermissions[nextResourceToSet], 'default_redirect'];
			}

			let obj = {
				role: '',
				resource: nextResourceToSet,
				permission: ['default_redirect'],
				user: this.rawId,
				branchIds: [this.model.branchPermission]
			};
			this.UserService.updateAcl(obj, true).catch(err => console.error('Error setting redirect ACL:', err));
		}
	}

	updateAclPermission(obj, allow, key, parentKey) {
		let self = this;
		if (this.model.sameForAll) {
			const defer = this.$q.defer();
			const branchIds = this.model.branch.map(data => data.id)
			let newObj = {
				role: !allow ? ('user:' + this.rawId) : '',
				permission: obj.permission,
				resource: obj.resource,
				user: this.rawId,
				branchIds: branchIds,
			}
			// console.log('newObj', newObj);
			updatePermission(newObj).then(res => defer.resolve())
			return defer.promise;
		}
		else {
			// console.log("obj", obj);
			updatePermission(obj)
		}

		function updatePermission(permissionObj) {
			const q = self.$q.defer();
			self.UserService.updateAcl(permissionObj, allow)
				.then((data) => {
					if (data == 'OK') {
						if (allow) {
							if (self.aclPermissions.hasOwnProperty(parentKey)) {
								let l = self.aclPermissions[parentKey].length
								if (key instanceof Array) self.aclPermissions[parentKey] = key;
								else {
									if (!self.aclPermissions[parentKey].includes(key))
										self.aclPermissions[parentKey][l] = key;
								}
							} else {
								if (parentKey.includes('tnt_billing') || parentKey.includes('tnt_control') || parentKey.includes('reporting') || parentKey.includes('order_packing') || parentKey.includes('bulk_transfer')) self.aclPermissions[parentKey] = key instanceof Array ? key : [key];
								else if (parentKey.includes('setting-')) {
									if (self.model.customerUser && parentKey == 'setting-location') {
										self.aclPermissions[parentKey] = ["view", "edit"]
									} else {
										self.aclPermissions[parentKey] = key instanceof Array ? key : [key];
									}
									// console.log(self.aclPermissions[parentKey])
								}
								else {
									self.aclPermissions[parentKey] = key instanceof Array ? key : [key];
								}
							}
						} else {
							if (['setting', 'tnt_billing', 'tnt_control', 'reporting', 'order_packing', 'bulk_transfer'].indexOf(parentKey) >= 0) {
								delete self.aclPermissions[parentKey];
								const tntBillingChild = self.permissions[parentKey].child;
								const resources = Object.keys(tntBillingChild);
								resources.map((resource) => {
									delete self.aclPermissions[resource];
								})
							} else {
								if (self.aclPermissions[parentKey]) {
									self.aclPermissions[parentKey] = self.aclPermissions[parentKey].filter(k => k && k !== key);
									const hasRedirect = self.aclPermissions[parentKey] && self.aclPermissions[parentKey].includes('default_redirect');
									if (self.aclPermissions[parentKey] && self.aclPermissions[parentKey].length === 0) {
										delete self.aclPermissions[parentKey];
									}

									if (key !== 'default_redirect' && hasRedirect) {
										const active = self.aclPermissions[parentKey] ? self.aclPermissions[parentKey].filter(k => k && k !== 'default_redirect') : [];
										if (active.length === 0) {
											let obj = {
												role: 'user:' + self.rawId,
												resource: parentKey,
												permission: ['default_redirect'],
												user: self.rawId,
												branchIds: [self.model.branchPermission]
											};
											self.UserService.updateAcl(obj, false).then(() => {
												if (self.aclPermissions[parentKey]) {
													self.aclPermissions[parentKey] = self.aclPermissions[parentKey].filter(k => k && k !== 'default_redirect');
													if (self.aclPermissions[parentKey].length === 0) {
														delete self.aclPermissions[parentKey];
													}
												}
												// Shift redirect back to parent category
												const parentCategory = self.getParentCategoryKey(parentKey);
												if (parentCategory) {
													if (!self.aclPermissions[parentCategory]) {
														self.aclPermissions[parentCategory] = [];
													}
													if (!self.aclPermissions[parentCategory].includes('default_redirect')) {
														self.aclPermissions[parentCategory] = [...self.aclPermissions[parentCategory], 'default_redirect'];
													}
													let parentObj = {
														role: '',
														resource: parentCategory,
														permission: ['default_redirect'],
														user: self.rawId,
														branchIds: [self.model.branchPermission]
													};
													self.UserService.updateAcl(parentObj, true).catch(err => console.error('Error shifting redirect:', err));
												}
											});
										}
									}
								}
							}
							self.cleanupOrphanedDefaultRedirects();
						}
						q.resolve()
					}
				}).catch((err) => {
					console.log('Error Updating permissions')
					console.log(err)
					q.resolve()
				})
			return q.promise;
		}
	}

	toggle = (language) => {
		this.model.languageId = language.value
	}

	isLangSelected = (language) => {
		return language.value == this.model.languageId;
	}

	// Reset Multi-Branch selection
	resetMultiBranchSelection() {
		let usersBranches = this.existingBranch.map((data) => data.branchId)
		if (this.model.branch && this.model.branch.length) {
			this.existingBranch.forEach((selectedBranch) => {
				this.branchData.filter((branch) => {
					let isIncludes = usersBranches.includes(branch.id)
					if (branch.id == selectedBranch.branchId) {
						branch.ticked = true;
					}
					if (!isIncludes) {
						branch.ticked = false;
					}
				})
			});
		}
	}

	reset(e) {
		// this.model = angular.copy(this.defaultModel)
		// this.model.branchId = this.defaultBranch;
		// this.model.branchPermission = this.defaultBranch;
		// console.log(this.model.branchPermission, this.model.branchId);
		// console.log(this.model);
		this.resetMultiBranchSelection();
		this.Service.get(this.$stateParams.id)
			.then((data) => {
				this.rawId = data.id
				this.model.id = data.id
				this.model.firstName = data.firstName
				this.model.lastName = data.lastName
				this.model.email = data.email
				this.model.languageId = data.languageId
				this.model.supervisor = data.supervisor
				this.model.branchId = data.branchId
				this.model.downloadToHHT = data.downloadToHHT
				this.model.isWebUser = !!data.email
				this.model.branchPermission = data.branchId;
				this.model.kabaKeyId = data.kabaKeyId;
				this.model.SGKeyId = data.SGKeyId;
				this.model.defaultAppView = data.defaultAppView || null;
				this.model.hhtPassword = data.hhtPassword
				this.model.phone = data.phone
				this.model.routeKeyId = data.routeKeyId
				this.model.tecnoDevId = data.tecnoDevId
				this.model.OTCCompanyName = data.OTCCompanyName
				this.OTCKeys = data.OTCKeys
				this.model.serviceUser = data.serviceUser;
				this.model.ATMTransfer = data.ATMTransfer;
				this.model.shipmentTransfer = data.shipmentTransfer;
				this.model.timezone = data.timezone;
				this.model.customerUser = data.customerUser;
				this.model.customer = this.mappingCustomerKeyVal(data.customer);
				this.model.autoCheckIn = this.enableAutoCheckInCheckOut && data.downloadToHHT ? data.autoCheckIn || false : false;
				this.model.autoCheckOut = this.enableAutoCheckInCheckOut && data.downloadToHHT ? data.autoCheckOut || false : false;
				this.model.payrollId = data.payrollId;
				this.model.serviceLevel = data.serviceLevel || null;
				this.model.userOrigin = data.userOrigin || null;
				this.model.address = data.address || null;
				this.model.city = data.city || null;
				this.model.state = data.state || null;
				this.model.zip = data.zip || null;
				this.model.country = data.country || null;
				this.model.isNonUSLocation = data.country && data.country !== 'US' ? true : false;
				this.model.lat = data.lat || null;
				this.model.long = data.long || null;
				this.model.limitToServiceZone = this.model.serviceUser ? data.limitToServiceZone || false : false;
				this.model.rejectTickets = (this.model.serviceUser || this.model.downloadToHHT) ? data.rejectTickets : false;
				this.model.selfAssignServiceTicket = this.model.serviceUser ? data.selfAssignServiceTicket : false;
				this.model.userAssignServiceTicket = this.model.serviceUser ? data.userAssignServiceTicket : false;
				this.model.addActions = this.model.serviceUser ? data.addActions || false : false;
				this.model.createTickets = this.model.serviceUser ? data.createTickets || false : false;
				this.loadSchedule(data.schedule);
			})
			.then(() => {
				this.autoSelectSameForAll();
			})
			.catch((e) => {
				console.log(e);
			})
	}

	resetWebUserData() {
		for (let key in this.model) {
			if (key == 'isWebUser') {
			}
			else {
				this.model["email"] = null
				this.model["password"] = null;
				this.cnfPassword = null
			}
		}
	}

	submit(evt) {
		if (!this.validate()) {
			return
		}
		if (this.hasScheduleErrors()) {
			return
		}

		if (!(this.model.isWebUser || this.model.customerUser)) {
			this.model.email = this.model.password = null;
		}

		let serviceZoneData = [];
		if (this.model.limitToServiceZone && this.model.selectedZones.length > 0) {
			serviceZoneData = this.model.selectedZones.map(zone => {
				return {
					locationZoneId: zone.zoneId, userId: this.model.id
				}
			}).filter(n => n !== undefined);
		}

		this.loading = true;
		var savedata = {
			id: this.model.id,
			firstName: this.model.firstName,
			lastName: this.model.lastName,
			email: this.model.email,
			languageId: this.model.languageId,
			supervisor: this.model.supervisor,
			password: this.model.password,
			branchId: this.model.branchId,
			downloadToHHT: this.model.downloadToHHT,
			kabaKeyId: (this.model.kabaKeyId && this.model.downloadToHHT) ? this.model.kabaKeyId : null,
			SGKeyId: (this.model.SGKeyId && this.model.downloadToHHT) ? this.model.SGKeyId : null,
			defaultAppView: (this.model.downloadToHHT || this.model.serviceUser) ? this.model.defaultAppView : null,
			// hhtPassword: this.model.hhtPassword ? this.model.hhtPassword : null,
			phone: this.model.phone ? this.model.phone : null,
			routeKeyId: (this.model.routeKeyId && this.model.downloadToHHT) ? this.model.routeKeyId : null,
			tecnoDevId: (this.model.tecnoDevId && this.model.downloadToHHT) ? this.model.tecnoDevId : null,
			OTCCompanyName: this.model.OTCCompanyName,
			OTCKeys: this.OTCKeys,
			serviceUser: this.model.serviceUser,
			ATMTransfer: this.model.ATMTransfer,
			shipmentTransfer: this.model.shipmentTransfer,
			timezone: this.model.timezone,
			customerUser: this.model.customerUser,
			customerId: this.model.customer ? this.model.customer.Value : null,
			autoCheckIn: this.enableAutoCheckInCheckOut && this.model.downloadToHHT ? this.model.autoCheckIn || false : false,
			autoCheckOut: this.enableAutoCheckInCheckOut && this.model.downloadToHHT ? this.model.autoCheckOut || false : false,
			payrollId: this.model.payrollId ? this.model.payrollId : null,
			limitToServiceZone: this.model.serviceUser ? this.model.limitToServiceZone || false : false,
			rejectTickets: (this.model.serviceUser || this.model.downloadToHHT) ? this.model.rejectTickets : false,
			selfAssignServiceTicket: this.model.serviceUser ? this.model.selfAssignServiceTicket : false,
			userAssignServiceTicket: this.model.serviceUser ? this.model.userAssignServiceTicket : false,
			addActions: this.model.serviceUser ? this.model.addActions : false,
			createTickets: this.model.serviceUser ? this.model.createTickets : false,
			serviceZoneData,
			usersBranches: this.model.branch.map(b => { if (b.ticked) return b.id }).filter(n => n !== undefined),
			companies: this.defaultModel.companies,
			selectedBranchFundingSource: this.branchFundingSourceGrouped.map(bfs => { if (bfs.ticked) return bfs.fundingSourceId }).filter(n => n !== undefined),
			branchCounterId: this.model.isWebUser ? this.model.branchCounterId : null,
			serviceLevel: this.model.serviceUser ? this.model.serviceLevel : null,
			userOrigin: this.model.serviceUser ? this.model.userOrigin : null,
			address: this.model.address || null,
			city: this.model.city || null,
			state: this.model.state || null,
			zip: this.model.zip || null,
			country: this.model.isNonUSLocation ? this.model.country : (this.model.address ? 'US' : null),
			lat: this.model.lat || null,
			long: this.model.long || null,
			make: this.model.serviceUser ? this.parseMakeValues(this.model.make) : [],
			schedule: (this.model.downloadToHHT || this.model.serviceUser || this.model.isWebUser) ? this.formatScheduleForSave() : null
		};

		savedata.changedObject = this.findDifferences(this.defaultModel, savedata);

		this.Service.update(this.rawId, savedata)
			.then((data) => {
				let currentLoggedInUser = this.User.getUser();
				if (currentLoggedInUser.id === this.model.id) {
					this.User.setUser(data);
				}
				this.updateUserBranch();
				this.updateUserFundingSourceGroup();
				if (currentLoggedInUser.id === data.id && currentLoggedInUser.branchId !== data.branchId) {
					this.$state.go('home');
					setTimeout(function () { this.window.location.reload(); }, 100);
				} else {
					this.$state.go('users.all', ({
						page: 1
					}), { reload: true })
				}
			})
			.catch((err) => {
				if (err && err.data && err.data.message) {
					this.Modal.errorModal(err.data.message);
				}
				else if (err && err.data && err.data.errors) {
					this.Modal.errorModal(err.data.errors[0].path);
				}
				else {
					this.Modal.errorModal(err);
				}
			})
			.finally(() => {
				this.loading = false;
			})
	}
	toggleExpand(perm) {
		// this.permissions[perm].expand = !this.permissions[perm].expand
		if (perm === 'branch_mgmt_billing_approval' && this.permissions.branch_mgmt && this.permissions.branch_mgmt.child && this.permissions.branch_mgmt.child.branch_mgmt_billing_approval) {
			this.permissions.branch_mgmt.child.branch_mgmt_billing_approval.expand = !this.permissions.branch_mgmt.child.branch_mgmt_billing_approval.expand;
		}

		if (perm === 'tnt_billing_fuel_surcharges' && this.permissions.tnt_billing && this.permissions.tnt_billing.child && this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges) {
			this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.expand = !this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.expand;
		}

		if (this.permissions[perm]) {
			this.permissions[perm].expand = !this.permissions[perm].expand;
		}
	}
	expand(parentKey) {
		//return !!this.permissions[parentKey].expand;
		if (parentKey === 'branch_mgmt_billing_approval' && this.permissions.branch_mgmt && this.permissions.branch_mgmt.child && this.permissions.branch_mgmt.child.branch_mgmt_billing_approval) {
			return !!this.permissions.branch_mgmt.child.branch_mgmt_billing_approval.expand;
		}

		if (parentKey === 'tnt_billing_fuel_surcharges' && this.permissions.tnt_billing && this.permissions.tnt_billing.child && this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges) {
			return !!this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.expand;
		}

		if (this.permissions[parentKey]) {
			return !!this.permissions[parentKey].expand;
		}
		// return false; 
	}

	remove(array, element) {
		return array.filter(e => e !== element);
	}

	// reset value of kabaKeyId & SGKeyId
	resetKeyId() {
		if (!this.model.downloadToHHT) {
			// this.model.kabaKeyId = null;
			// this.model.SGKeyId = null;
			// this.model.routeKeyId = null;
			// this.model.tecnoDevId = null;
			// this.model.OTCCompanyName = null;
			this.model.make = [];
			this.loadAtmMakes();
			this.OTCKeys = {};
			this.setOtcKeys();
			this.model.autoCheckIn = false;
			this.model.autoCheckOut = false;
			this.isDisabledSupervisor = false;
		}
	}

	// update branch data
	updateUserBranch() {
		this.model.branch = this.model.branch.map((branchObj) => branchObj.id)
		this.UserService.updateBranchGrouped({
			userId: this.model.id,
			branchs: this.model.branch
		})
			.then((res) => {
			})
			.catch((err) => {
				console.log(err)
			});
	}

	getBranchPermission() {
		this.UserService.acl(this.rawId, this.model.branchPermission)
			.then((data) => {
				this.aclPermissions = data;
				this.sanitizeCashActivityPermissions(this.aclPermissions);
			})
		this.UserService.role(this.rawId, this.model.branchPermission)
			.then((data) => {
				this.aclRole = data
				this.role.user = this.aclRole.find((role) => {
					return role !== 'admin';
				});
			})
	}

	dropdownBranchPermission() {
		this.model.branchPermission = this.model.branchId;
		this.getBranchPermission();
	}

	changePassword(isWebPassword) {
		let modelData = Object.assign(this.model, { 'isWebPassword': isWebPassword || false });
		this.Modal.changePassword(modelData, ({ modal }) => {
			modal.close();
		}, ({ modal }) => {
			modal.close()
		})
	}

	autoSelectSameForAll() {
		// this.$scope.$watch(() => {
		// 	return this.model.branch
		// }, (branches) => {
		// 	console.log(branches.length);
		// 	if (branches.length > 1) return this.model.sameForAll = true;
		// 	else return this.model.sameForAll = false;
		// })
		if (this.model.branch.length > 1) return this.model.sameForAll = true;
		else return this.model.sameForAll = false;
	}

	loadServiceZone(branchIds, preserveIds) {
		return this.$q((resolve) => {
			setTimeout(() => {
				const selectedBranch = (branchIds && branchIds.length)
					? branchIds
					: (Array.isArray(this.model.branch) ? this.model.branch.map((branch) => branch.id) : []);
				const preserve = preserveIds || (this.model.selectedZones || []).map((zone) => zone.zoneId);
				const searchObj = {
					queryJSON: {
						rules: [{ field: 'branchId', condition: 'IN', data: selectedBranch }],
						operator: 'AND'
					}
				};
				this.LocationZoneService.all(searchObj, 0, 1000)
					.then((data) => {
						this.serviceZoneData = this.serviceZoneMap(data.results || [], preserve);
						this.model.selectedZones = this.serviceZoneData.filter((zone) => zone && zone.zoneId != null && zone.ticked);
						resolve();
					});
			});
		});
	}

	serviceZoneMap(records, preserve) {
		const DAY_ORDER = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY', 'HOLIDAY'];
		const byBranch = _.groupBy(records || [], 'branchId');

		const grouped = [];
		Object.keys(byBranch).sort().forEach((branchId) => {
			grouped.push({ label: `<strong>${branchId}</strong>`, msGroup: true });
			const byDay = _.groupBy(byBranch[branchId], 'dayOfWeek');
			DAY_ORDER.filter((d) => byDay[d]).forEach((day) => {
				grouped.push({ label: `<strong>${day}</strong>`, msGroup: true });
				byDay[day].forEach((z) => {
					const info = z.id + ' | ' + z.name + ' (' + z.branchId + ', ' + z.dayOfWeek + ')';
					grouped.push({
						zoneName: z.name, zoneId: z.id, zoneInfo: info,
						label: z.id + ' | ' + z.name, userId: this.model.id,
						ticked: preserve.includes(z.id)
					});
				});
				grouped.push({ msGroup: false });
			});
			grouped.push({ msGroup: false });
		});
		return grouped;
	}

	syncWithOTC(company) {
		const name = this.model.firstName.concat(' ', this.model.lastName);

		this.isSyncWithOTC = {};
		this.userData = [];
		this.isSyncWithOTC[company] = { process: true };
		this.userData.push({ phone: this.model.phone, OTCCompanyName: company, name: name })

		this.Service.updateUserKeys(this.userData)
			.then((res) => {
				// if (res && res.result && res.result[0].result == 0) {
				// }
				if (res && res.result && res.result[0].result == 1) {
					this.Modal.errorModal(res.result[0].message);
				}
				setTimeout(() => {
					this.loadData(company); // reLoad Data after syncWithOTC
				}, 1000)
			})
			.catch((err) => {
				console.log(err);
				if (err && err.data && err.data.message) {
					this.Modal.errorModal(err.data.message)
				}
			})
			.finally(() => {
				this.isSyncWithOTC[company].process = false;
			})
	}

	loadData(company) {
		this.Service.get(this.$stateParams.id)
			.then((data) => {
				this.OTCKeys[company] = data.OTCKeys[company];
			})
			.catch((e) => {
				console.log(e);
			})
	}

	setOtcKeys() {
		this.company = this.CommonLayoutService.setOTCKeys(this.OTCCompanies).company;
		this.OTCKeys = this.CommonLayoutService.setOTCKeys(this.OTCCompanies).OTCKeys;
	}

	assignPermissions() {
		let obj = {
			user: this.rawId,
			branchIds: this.model.branch.map(data => data.id)
		};
		if (this.model.sameForAll = !this.model.sameForAll) {
			this.UserService.updatePermissions(obj)
				.then((data) => {
					this.getBranchPermission(); // reload permission after apply same for all branch
				})
				.catch((err) => {
					console.log(err);
				})
		}
	}

	OTCCompanyMap() {
		this.OTCCompanyNameList = this.CommonLayoutService.OTCCompanyMapping(this.OTCCompanies);
	}

	getFundingSource(branches) {
		setTimeout(() => {
			let selectedBranch = [];
			if (branches && branches.length) selectedBranch = Array.isArray(branches) ? branches.map((branch) => branch.branchId) : branches.split();
			else selectedBranch = Array.isArray(this.model.branch) ? this.model.branch.map((branch) => branch.id) : this.model.branch.split();

			const searchObj = {
				queryJSON: {
					rules: [{
						field: 'branchId',
						condition: 'IN',
						data: selectedBranch
					},
					],
					operator: 'AND'
				}
			};

			this.loadFundingSource = true;
			this.BranchFundingSourceService.all(searchObj, 0, 1000, null)
				.then((data) => {
					this.branchFundingSourceData = data.results;
					this.branchFundingSourceGrouped = [];
					let grouped = _.groupBy(this.branchFundingSourceData, 'branchId')
					let keys = Object.keys(grouped);
					let indexMap2 = {}
					const indexMap = {}, addHeader = {};

					keys.forEach(k => {
						delete indexMap2[k];
						grouped[k].forEach(g => {
							if (!addHeader.hasOwnProperty('header')) {
								addHeader['header'] = true;
								this.branchFundingSourceGrouped.push(
									{
										label: '<strong>All Branch Funding Source</strong>',
										msGroup: true
									})
							}
							if (!indexMap.hasOwnProperty(g.branchId)) {
								indexMap[g.branchId] = grouped[k].length;
								this.branchFundingSourceGrouped.push(
									{
										label: `<strong>${k}</strong>`,
										msGroup: true
									},
								)
							}
							this.branchFundingSourceGrouped.push(
								{
									name: g.sourceName,
									branch: g.branchId,
									fundingSourceId: g.id,
									label: g.sourceName + ' | ' + '(' + g.locationId + ')',
									ticked: false
								},
							)
						})
						if (!indexMap2.hasOwnProperty(k)) {
							indexMap2[k] = 0;
							this.branchFundingSourceGrouped.push(
								{
									msGroup: false
								})
						}
					})
					this.branchFundingSourceGrouped.push({ msGroup: false });
					this.branchFundingSourceGrouped.forEach((bfs) => {
						this.userBranchFundingSourceData.forEach((data) => {
							if (data) {
								if (data.branchFundingSourceId === bfs.fundingSourceId) {
									bfs.ticked = true
								}
							}
						})
					})
					this.defaultModel.selectedBranchFundingSource = this.branchFundingSourceGrouped.map(bfs => { if (bfs.ticked) return bfs.fundingSourceId }).filter(n => n !== undefined);
					// return delegates.map(function (delegate) { return delegate.replace("undefined", "") }).join(",");
				})
				.catch((err) => {
					console.log(err);
				})
				.finally(() => {
					this.loadFundingSource = false;
				})
		})
	}

	getUserbranchFundingSource() {
		const searchObj = {
			queryJSON: {
				rules: [{
					field: 'userId',
					condition: '=',
					data: this.model.id
				},
				],
				operator: 'AND'
			}
		};

		return this.UserBranchFundingSourceService.all(searchObj, 0, 1000)
			.then((data) => {
				this.userBranchFundingSourceData = data.results;
			})
			.catch((err) => {
				console.log(err);
			})
	}

	isServiceOnlyUser() {
		return this.model.serviceUser && !this.model.isWebUser && !this.model.supervisor && !this.model.downloadToHHT;
	}

	updateUserFundingSourceGroup() {
		const fundingSource = this.isServiceOnlyUser() ? [] : (this.selectedFundingSource || []);
		return this.UserBranchFundingSourceService.updateUserFundingSourceGroup(this.model.id, fundingSource)
			.then(() => void undefined)
			.catch((err) => {
				console.log(err);
			});
	}

	getSetupDetails() {
		this.usersDefaultBranch = _.find(this.setupInfo, { branchId: this.model.branchId });
	}

	setCustomerUser(flag) {
		if (flag && this.model.customerUser) {
			this.model.serviceUser = false;
			this.model.supervisor = false;
			this.model.downloadToHHT = false;
			this.model.isWebUser = false;
			this.selectedFundingSource = [];
			this.removeAssignPermissions();
		} else if (!flag && (this.model.serviceUser || this.model.supervisor || this.model.downloadToHHT || this.model.isWebUser)) {
			this.model.customerUser = false;
			this.model.customer = null;
		} else if (flag && !(this.model.serviceUser || this.model.supervisor || this.model.downloadToHHT || this.model.isWebUser)) {
			this.model.customer = null;
		}
		this.removeAssignPermissions();
	}

	hasActiveAncestors(resource) {
		if (this.permissions[resource]) {
			return true;
		}

		let parentKey = null;
		for (const [topKey, topVal] of Object.entries(this.permissions)) {
			if (topVal.child && topVal.child[resource]) {
				parentKey = topKey;
				break;
			}
			if (topVal.child) {
				for (const [childKey, childVal] of Object.entries(topVal.child)) {
					if (childVal.child && childVal.child[resource]) {
						parentKey = childKey;
						break;
					}
				}
				if (parentKey) break;
			}
		}

		if (!parentKey) return true;

		if (!this.hasAnyPerm(parentKey)) {
			return false;
		}

		return this.hasActiveAncestors(parentKey);
	}

	disabledPermissions(parent, child) {
		if (parent == 'branch_mgmt_restore_route_assignments') {
			return true;
		}
		
		if (this.model.customerUser) {
			if (child) {
				// 	if (child == 'create' && parent == 'service_tickets') {
				// 		return true;
				// 	}
				if (parent == 'setting-location' && ['create', 'importLocations', 'clone', 'editCustomer'].indexOf(child) >= 0) return true;
			if (parent == 'bulk_cash_management' && child !== 'view' && child !== 'export') return true;
			}
			return (0 > this.customerPermissions.indexOf(parent))
		} else if (this.model.isWebUser) {
			return false
		} else {
			return true
		}
	}

	removeAssignPermissions() {
		if (!this.model.isWebUser) {
			let parentKeys = Object.keys(this.aclPermissions)
			parentKeys.map((parentKey) => {
				if (this.model.customerUser && 0 > this.customerPermissions.indexOf(parentKey)) {
					this.aclPermissions[parentKey].forEach(permission => {
						this.togglePerm(permission, parentKey)
					})

				} else if (!this.model.customerUser && !this.model.isWebUser) {
					this.aclPermissions[parentKey].forEach(permission => {
						this.togglePerm(permission, parentKey)
					})
				}
			})

		}
	}

	customerSearchPaginate(searchKey, idKey, nameKey) {
		return {
			queryJSON: {
				rules: [{
					field: idKey,
					condition: 'like',
					data: '%' + searchKey + '%'
				},
				{
					field: nameKey,
					condition: 'like',
					data: '%' + searchKey + '%'
				}
				],
				operator: 'OR'
			}
		}
	}

	getCustomer(searchKey, offset) {
		searchKey = searchKey || '';
		let costomerSearchObj = this.customerSearchPaginate(searchKey, 'id', 'name')
		if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
			offset = offset - 1;
		}
		return this.CustomerService.all(costomerSearchObj, offset, AppConstants.defaultPageLimit)
			.then((res) => {
				let selectedVal = this.model.customer ? this.model.customer.Value : '';
				if (offset === 0 || offset == undefined) {
					this.totalCustomer = res.total;
					let customers = this.mappingCustomerDatas(res.results);
					if (!searchKey && selectedVal) {
						customers.unshift(this.model.customer);
					}
					this.customerList = _.uniqBy(customers, 'Value');
				}
				else {
					const customers = this.mappingCustomerDatas(res.results);
					this.customerList = _.uniqBy(this.customerList.concat(customers), 'Value');
				}
			})
			.catch((err) => {
				if (err && err.data && err.data.message) {
					this.errorMessage = err.data.message;
				}
			})
	}

	mappingCustomerKeyVal(obj) {
		if (obj == null) return obj;
		obj.Key = obj.id + ' | ' + obj.name,
			obj.Value = obj.id
		return obj;
	}

	mappingCustomerDatas(customers) {
		return customers.map((customer) => {
			const customerObj = {
				Key: customer.id + ' | ' + customer.name,
				Value: customer.id
			};

			return customerObj;
		});
	}

	validateAutoChekInChekOut() {
		if (!this.model.branchId) return;
		const selectedBranch = _.find(this.setupInfo, { branchId: this.model.branchId });
		this.enableAutoCheckInCheckOut = selectedBranch.enableAutoCheckInCheckOut;
	}

	forceSupervisorToSetOn() {
		if (this.model.downloadToHHT && (this.model.autoCheckIn || this.model.autoCheckOut)) {
			this.isDisabledSupervisor = true;
			this.model.supervisor = true;
		}
		else {
			// this.model.supervisor = false;
			this.isDisabledSupervisor = false;
		}
	}

	resetServiceZone() {
		if ((!this.model.serviceUser || !this.model.limitToServiceZone)) {
			if (!this.model.serviceUser) {
				this.model.limitToServiceZone = false;
			}
			setTimeout(() => {
				this.model.selectedZones = [];
				this.serviceZoneData.forEach(zone => {
					zone.ticked = false;
				});
			})
		}
	}

	clearFundingSourceIfServiceOnly() {
		if (this.isServiceOnlyUser()) {
			this.selectedFundingSource = [];
			(this.branchFundingSourceGrouped || []).forEach((bfs) => {
				bfs.ticked = false;
			});
		}
	}

	findDifferences(objA, objB) {
		function compareObjects(obj1, obj2) {
			let diff = {};

			for (let key in obj1) {
				if (obj1.hasOwnProperty(key)) {
					if (typeof obj1[key] === 'object' && obj1[key] !== null && obj2[key] !== null) {
						if (Array.isArray(obj1[key])) {
							if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
								diff[key] = {
									"Old Value": obj1[key],
									"Updated Value": obj2[key]
								};
							}
						} else if (obj2[key] !== undefined && obj1[key] !== undefined) {
							const nestedDiff = compareObjects(obj1[key], obj2[key]);
							if (Object.keys(nestedDiff).length > 0) {
								diff[key] = nestedDiff
							}
						}
					} else if (obj1[key] !== obj2[key] && obj2[key] !== undefined && obj1[key] !== undefined) {
						diff[key] = {
							"Old Value": obj1[key],
							"Updated Value": obj2[key]
						};
					}
				}
			}

			return diff;
		}

		return compareObjects(objA, objB);
	}

	parseMakeValues(makeValue) {
		if (Array.isArray(makeValue)) {
			return makeValue
				.map((item) => {
					if (!item) return null;
					if (typeof item === 'string') {
						const vendorName = item.trim();
						return vendorName ? { atmMakeId: null, vendorName } : null;
					}
					const vendorName = (item.vendorName || item.Value || item.value || item.Key || item.label || '').trim();
					const atmMakeId = item.atmMakeId || item.id || (item.atmMake && item.atmMake.id) || null;
					return vendorName ? { atmMakeId, vendorName } : null;
				})
				.filter(Boolean);
		}

		if (!makeValue) return [];

		return String(makeValue)
			.split(',')
			.map((item) => item.trim())
			.filter(Boolean)
			.map((vendorName) => ({ atmMakeId: null, vendorName }));
	}

	serializeMakeValues(makeValue) {
		const values = this.parseMakeValues(makeValue);
		return values.length ? values.map((item) => item.vendorName).join(', ') : null;
	}

	buildAtmMakeOptions(results, selectedMakes) {
		const selectedValues = this.parseMakeValues(selectedMakes);
		const selectedById = selectedValues.map((item) => item.atmMakeId).filter(Boolean);
		const selectedByName = selectedValues.map((item) => item.vendorName).filter(Boolean);
		const options = (results || [])
			.filter((item) => item.active)
			.map((item) => ({
				Key: item.vendorName,
				Value: item.vendorName,
				id: item.id,
				atmMakeId: item.id,
				vendorName: item.vendorName,
				ticked: selectedById.includes(item.id) || selectedByName.includes(item.vendorName)
			}));

		selectedValues.forEach((selectedItem) => {
			if (options.findIndex((item) => item.atmMakeId === selectedItem.atmMakeId || item.Value === selectedItem.vendorName) === -1) {
				options.push({
					Key: selectedItem.vendorName,
					Value: selectedItem.vendorName,
					id: selectedItem.atmMakeId || selectedItem.vendorName,
					atmMakeId: selectedItem.atmMakeId,
					vendorName: selectedItem.vendorName,
					ticked: true
				});
			}
		});

		return options;
	}

	loadAtmMakes(selectedMakes = this.model.make) {
		return this.AtmMakesService.all('', 0, 1000)
			.then(({ results }) => {
				this.atmMakesList = this.buildAtmMakeOptions(results, selectedMakes);
				this.model.make = this.parseMakeValues(selectedMakes);
			})
			.catch((err) => {
				console.log(err);
				this.atmMakesList = [];
				this.model.make = [];
			});
	}
	
		loadSchedule(schedule) {
		this.model.schedule = {};
		this.scheduleErrors = {};
		if (schedule) {
			this.scheduleDays.forEach(day => {
				this.model.schedule[day.startKey] = this.parseTimeString(schedule[day.startKey]) || null;
				this.model.schedule[day.endKey] = this.parseTimeString(schedule[day.endKey]) || null;
				day.active = !!schedule[day.startKey];
			});
		} else {
			this.scheduleDays.forEach(day => {
				this.model.schedule[day.startKey] = null;
				this.model.schedule[day.endKey] = null;
				day.active = false;
			});
		}
	}

	toggleScheduleDay(day) {
		day.active = !day.active;
		if (!day.active) {
			this.model.schedule[day.startKey] = null;
			this.model.schedule[day.endKey] = null;
			delete this.scheduleErrors[day.key + 'Order'];
		}
		this.validateScheduleDay(day);
	}

	validateScheduleDay(day) {
		delete this.scheduleErrors[day.key + 'Order'];

		if (day.active) {
			if (this.model.schedule[day.startKey] && this.model.schedule[day.endKey]) {
				const start = this.formatTimeOnly(this.model.schedule[day.startKey]);
				const end = this.formatTimeOnly(this.model.schedule[day.endKey]);
				if (start && end && start >= end) {
					this.scheduleErrors[day.key + 'Order'] = true;
				}
			}
		}
	}

	hasScheduleErrors() {
		return Object.keys(this.scheduleErrors).length > 0;
	}

	formatScheduleForSave() {
		const schedule = {};
		this.scheduleDays.forEach(day => {
			schedule[day.startKey] = this.formatTimeOnly(this.model.schedule[day.startKey]);
			schedule[day.endKey] = this.formatTimeOnly(this.model.schedule[day.endKey]);
		});
		return schedule;
	}

	parseTimeString(timeStr) {
		if (!timeStr || typeof timeStr !== 'string') return null;
		const [hours, minutes] = timeStr.split(':');
		const d = new Date();
		d.setHours(parseInt(hours, 10));
		d.setMinutes(parseInt(minutes, 10));
		d.setSeconds(0);
		d.setMilliseconds(0);
		return d;
	}

	formatTimeOnly(val) {
		if (!val) return null;
		if (typeof val === 'string' && /^\d{2}:\d{2}(:\d{2})?$/.test(val)) return val;
		const d = new Date(val);
		if (isNaN(d.getTime())) return null;
		const h = String(d.getHours()).padStart(2, '0');
		const m = String(d.getMinutes()).padStart(2, '0');
		return h + ':' + m;
	}

	getBranchCounters(){
		if(this.model.branchId){
    return this.UserService.getBranchCounters(this.model.branchId)
		.then((data) => {
			const counters = data.branchCounters || [];
			this.countStationList = counters.map(cs => ({
				label: cs.name || cs.label || cs.id, 
				value: cs.id
			}));
		})
	}
}
}

export default UsersEditController;



// WEBPACK FOOTER //
// ./client/app/components/users/edit/users.edit.controller.js